module.exports = __webpack_public_path__ + "static/media/freelancelogo.70a560f4.webp";